import { LOCATION_CHANGE } from 'connected-react-router';

const DEFAULT_STATE = {
  previousLocation: null,
};

export function navigation(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!state.previousLocation && !state.currentLocation) {
        return {
          ...state,
          currentLocation: action.payload.location.pathname,
          previousLocation: action.payload.location.pathname,
        };
      }

      if (state.currentLocation === action.payload.location.pathname) {
        return state;
      }

      return {
        ...state,
        currentLocation: action.payload.location.pathname,
        previousLocation: state.currentLocation,
        visible: true,
      };
    default:
      return state;
  }
}
